import Image from '@components/Image'
import { ElementHTML } from '@helpers/helper.rendering'
import { Link } from 'gatsby'
import React, { useEffect, useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import { RealEstateDataPageComponentData } from 'types'

const AboutUs_21 = (props: RealEstateDataPageComponentData) => {
  const { image_gatsby, title, titleElement, titleHexa, paragraphs, button, height } = props

  const [isMounted, setIsMounted] = useState(false)

  useEffect(() => {
    setIsMounted(true)
  }, [])

  const getHeight = (): string => {
    const isMobile = isMounted && window.innerWidth <= 992
    if (!height) {
      return isMobile ? '50vh' : '90vh'
    }
    const baseHeight = isMobile ? height.mobile : height.desktop
    return height.scalePixels ? `${baseHeight}px` : `${baseHeight}vh`
  }

  return (
    isMounted && (
      <section
        id="about-us"
        className="p-y-config about-21"
      >
        <Row className="h-100">
          {image_gatsby && (
            <Col
              xs={12}
              md={10}
              className="h-100 position-relative"
            >
              <Col
                md={10}
                xs={12}
              >
                <Image
                  image={image_gatsby}
                  objectFit="cover"
                  alt="img-aboutus"
                  className=""
                  style={{
                    height: getHeight(),
                  }}
                />
              </Col>
              <div className="content-div p-5">
                <ElementHTML
                  children={title ?? 'Nosotros'}
                  elementType={titleElement ?? 'h3'}
                  className={'mb-lg-4 mt-lg-1 mb-3'}
                  style={{ color: titleHexa }}
                />
                {paragraphs?.map((paragraph, index) => (
                  <ElementHTML
                    key={index}
                    children={paragraph}
                    elementType="p"
                  />
                ))}
                {button && (
                  <Link
                    to={button.link || ''}
                    className={`btn btn-primary ${button.border ? 'border' : ''} mt-3`}
                  >
                    {button.value}
                    {button.image && (
                      <img
                        src={button.image}
                        className="button-logo"
                      />
                    )}
                  </Link>
                )}
              </div>
            </Col>
          )}
        </Row>
      </section>
    )
  )
}

export default AboutUs_21
